export const EW_REMOVAL_SCREENS = {
    WARRANTY_REMOVAL: "WARRANTY_REMOVAL",
    WARRANTY_REMOVAL_CONFIRMATION: "WARRANTY_REMOVAL_CONFIRMATION"
};
